import colors from './colors';

export default {
  colors: Object.values(colors).reduce((output, color) => {
    return { ...output, ...color };
  }, {}),
  transitionDuration: '0.3s',
};
